module.exports = __webpack_public_path__ + "static/img/hot.b3e42dff.svg";